// extracted by mini-css-extract-plugin
export default {"main":"PrivacyPolicy_main__mE-2e","fadeIn":"PrivacyPolicy_fadeIn__i5ma5"};